import { ManualCorrectionForm } from './ManualCorrectionForm';

const REGULATION = [
  "Ручная корректировка предназначена исключительно для исправления ошибок killtracker'а системы записи реплеев и не заменяет штатный учёт статистики.",
  'Укажите ссылку на реплей из Replay Viewer, участников, тайминг события и обстоятельства. При наличии приложите до пяти HTTP-ссылок на подтверждающие материалы.',
  'Корректировка производится только когда факт ошибки можно установить с достаточной уверенностью. При нехватке данных или неоднозначности администрация вправе отказать.',
  'Каждую заявку независимо рассматривают два проверяющих. Проверяющий не участвует в рассмотрении, если его отряд совпадает с отрядом заявленного автора фрага или жертвы.',
  'Злоупотребление системой и заведомо ложные сведения могут стать основанием для отказа в последующих обращениях.',
];

export function ManualCorrectionsPage({
  onNavigate,
}: {
  onNavigate: (path: string) => void;
}): JSX.Element {
  return (
    <main className="mx-auto w-full max-w-7xl space-y-8 px-4 py-6 sm:px-6">
      <header className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Ручная корректировка</p>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight">Сообщить об ошибке подсчёта фрага</h1>
        <p className="mt-3 text-muted-foreground">
          Заявка не меняет статистику мгновенно: после двойной проверки одобренная запись ожидает штатного пересчёта.
        </p>
      </header>

      <section aria-labelledby="manual-correction-regulation" className="rounded-lg border border-border bg-card p-4 sm:p-6">
        <h2 id="manual-correction-regulation" className="text-2xl font-semibold">Регламент</h2>
        <ol className="mt-4 space-y-3 pl-5 text-sm leading-6 text-foreground/90">
          {REGULATION.map((paragraph, index) => (
            <li key={paragraph} className="list-decimal pl-1">{paragraph}</li>
          ))}
        </ol>
      </section>

      <ManualCorrectionForm
        onSubmitted={(correction) => onNavigate(`/manual-corrections/${correction.public_id}`)}
      />
    </main>
  );
}
